import $ from 'jquery';
import ModalLink from '../classes/ModalLink';

$(() => {
  $('body').on('click', '.e1-modal-link', async ({ currentTarget }) =>
    new ModalLink($(currentTarget)).submit(),
  );
});
